import { HazardTypes } from '../../../../constants';
import { HazardType, Status } from './HazardForm.types';

export type HazardTypeOption = {
  transKey: string;
  value: HazardType;
};

export const hazardTypes: HazardTypeOption[] = [
  {
    transKey: 'hazard.types.swiftWater',
    value: HazardTypes.swiftWater,
  },
  {
    transKey: 'hazard.types.standingWater',
    value: HazardTypes.standingWater,
  },
  {
    transKey: 'hazard.types.roadWashout',
    value: HazardTypes.roadWashout,
  },
  {
    transKey: 'hazard.types.damLeveeFailure',
    value: HazardTypes.damLeveeFailure,
  },
  {
    transKey: 'hazard.types.hazmat',
    value: HazardTypes.hazmat,
  },
  {
    transKey: 'hazard.types.other',
    value: HazardTypes.other,
  },
];

export const statusOptions: { transKey: string; value: Status }[] = [
  { transKey: 'common.active', value: 'active' },
  { transKey: 'common.inactive', value: 'inactive' },
];
